const { wrapRootElement } = require("./src/gatsby/wrapRootElement.tsx");

exports.wrapRootElement = wrapRootElement;
